export default "__VITE_ASSET__Cd8l_NFw__"